import React from 'react'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'
import complete from '../../images/booth/check.png'
import { useSelector } from 'react-redux';
import LoadIcon from '../LoadIcon';

const Wrapper = styled.div`
  font-weight: 600;
  color: #3A2D86;
  letter-spacing: 1px;
  .screen-title {
    text-align: center;
    font-size: 20px;
    margin: 0 auto;
  }
  .message-container {
    padding: 18px 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 16px 0;
    img {
      width: 12%;
    }
    p {
      font-size: 24px;
      text-align: center;
    }
  }
`

export default function FinishScreen({numberOfCorrect}) {
  const { userScore, submitting } = useSelector((state) => state.booth)
  return (
    <Wrapper>
      <Modal.Header>
        <p className="screen-title">Thank You For Your Participation!</p>
      </Modal.Header>
      <div className="message-container">
        {submitting ? <LoadIcon spinnerColor="#002060" />
        :
          userScore === 5 ?
          <>
            <img src={complete} alt="complete tick"/>
            <div>
              <p>Congratulations! You score 5 out of 5!</p>
            </div>
          </> 
          :
          <div>
            <p className="result">You score {numberOfCorrect} out of 5!</p>
            <p className="result">Don't give up, try again!</p>
          </div>
        }
      </div>
    </Wrapper>
  )

}
